
import { Component, Vue } from 'vue-property-decorator'

import { Http } from '../../lib/utils/Http'
import { SerializationHelper } from '../../lib/utils/SerializationHelper'

import BacInput from '@/components/BacInput.vue'
import BacButton from '@/components/BacButton.vue'
import RateChallengesTable from './RateChallengesTable.vue'
import { RatingChatMessage } from '@/lib/dtos/RatingChatMessage'
import { Game } from '../../lib/models/Game'
import UIkit from 'uikit'
import BacTextarea from '../BacTextarea.vue'
import BacModal from '../BacModal.vue'

@Component({
  components: {
    RateChallengesTable,
    BacInput,
    BacButton,
    BacTextarea,
    BacModal
  }
})
export default class RateChallenges extends Vue {
  unratedChallenges: RatingChatMessage[] = []
  unratedOriginals: RatingChatMessage[] = [] // deep copy of unratedChallenges for filtering
  ratedChallenges: RatingChatMessage[] = []
  challenges: Game[] = []

  headers = [
    { text: 'Nachricht', value: 'content', width: '25%', align: 'center' },
    { text: 'Eingereicht', value: 'sendIn', width: '18%', align: 'center' },
    { text: 'Team', value: 'team', width: '30%', align: 'center' },
    { text: 'Punkte', value: 'points', width: '6%' },
    { text: 'Aktionen', value: 'actions', width: '12%' }
  ];

  search = ''

  mounted () {
    this.loadMessages()
    this.loadRallyRoundChallenges()
  }

  getUnratedChallengesByChallenge (challengeId: number) {
    return this.unratedChallenges.filter(post => post.gameId === challengeId)
  }

  getUnratedOriginalsByChallenge (challengeId: number) {
    return this.unratedOriginals.filter(post => post.gameId === challengeId)
  }

  async loadRallyRoundChallenges () {
    this.challenges = await Game.getForRallyRound(parseInt(this.$route.params.rallyRoundId))
  }

  async loadMessages () {
    const res = await Http.request(
      `/api/rally-round/${this.$route.params.rallyRoundId}/posts/challenges/`
    )
    let data = await res.json()

    // map different db name
    data = data.map((message: any) => {
      message.content = message.message
      return message
    })

    const messages = SerializationHelper.toInstanceArray(RatingChatMessage, data, {
      idName: 'post'
    })

    this.unratedChallenges = messages
      .sort((a, b) => {
        if (!a.createdAt || !b.createdAt) return -1
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      })
      .map(challenge => {
        if (!challenge.team) {
          return challenge
        }
        challenge.selectedTeams = [challenge.team]
        return challenge
      })
    this.unratedOriginals = JSON.parse(JSON.stringify(this.unratedChallenges))

    // this.ratedChallenges = (messages as RatingChatMessage[])
    // .filter(message => message.points !== null)
    // .sort((a, b) => { if (!a.id || !b.id) { return -1 } return b.id - a.id })
  }

  async saveRatingPoints (message: RatingChatMessage) {
    await Http.request(`/api/post/${message.id}/rate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(message)
    })
    this.loadMessages()
  }

  async saveRatingAsRated (message: RatingChatMessage) {
    message.points = 0
    await Http.request(`/api/post/${message.id}/rate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(message)
    })
    this.loadMessages()
  }

  async removeRating (message: RatingChatMessage) {
    await Http.request(`/api/post/${message.id}/rate`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(message)
    })
    this.loadMessages()
  }

  async setConfirmed (challenge: Game) {
    await Http.request(`/api/messages/challenges/set-confirmed/${this.$route.params.rallyRoundId}/${challenge.id}`, {
      method: 'POST'
    })
    this.loadMessages()
  }

  selectedPostId: number | null = null
  note = ''
  async addNote () {
    await Http.request(
      `/api/post/${this.selectedPostId}/note`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: this.note })
      }
    )
    this.note = ''
    if (UIkit.modal('#add-note-modal')) {
      UIkit.modal('#add-note-modal').hide()
    }
    this.loadMessages()
  }
}
